import React from "react";
import { isLaunchOfferActive, planPrice, LAUNCH_OFFER_LABEL } from "@/lib/plans";

const SIZE = {
  sm: { price: "text-2xl", list: "text-xs" },
  md: { price: "text-3xl", list: "text-sm" },
  lg: { price: "text-3xl", list: "text-sm" },
};

export default function PlanPrice({ plan, size = "md", showOfferNote = true, className = "" }) {
  const offer = isLaunchOfferActive();
  const price = planPrice(plan);
  const sz = SIZE[size] || SIZE.md;

  return (
    <div className={className} data-testid={`plan-price-block-${plan.id}`}>
      {offer && (
        <p className={`${sz.list} text-muted-foreground`} data-testid={`plan-list-price-${plan.id}`}>
          <span className="line-through decoration-2">${plan.listPrice}</span>
        </p>
      )}
      <div className="flex items-baseline gap-1">
        <span className={`font-display font-extrabold tracking-tight ${sz.price}`} data-testid={`plan-price-${plan.id}`}>
          ${price}
        </span>
        <span className="text-xs text-muted-foreground">/mo</span>
      </div>
      {offer && showOfferNote && (
        <p className="mt-1 text-[11px] font-semibold text-amber-600 dark:text-amber-400" data-testid={`launch-offer-${plan.id}`}>
          Launch offer · until {LAUNCH_OFFER_LABEL}
        </p>
      )}
    </div>
  );
}
